import { useState } from "react"

import { Flex, Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../../../Components/Button"
import SelectComponent from "../../../../../Components/Select"
import Icon from "../../../../../Icon"

const { Text } = Typography

const modalContent = {
  activate: {
    title: "Activate a webhook endpoint",
    text: "Once activated, this endpoint will start receiving Chargeback notifications in real time. Make sure your server is ready to process incoming events before enabling it.",
    onOkText: "Activate"
  },
  disable: {
    title: "Disable a webhook endpoint",
    text: "This webhook endpoint can be temporarily disabled. While disabled, it will not receive Chargeback notifications. Any notifications generated during this time will not be retried once the endpoint is re-enabled.",
    onOkText: "Disable"
  },
  expire_secret: {
    title: "Expire secret",
    text: "Set an expiration date for this secret. Once expired, it will be automatically revoked.",
    select: "period",
    options: ["4 hours", "6 hours", "8 hours", "10 hours", "12 hours", "24 hours"],
    text2: "After it expires, new signatures will no longer be generated with the old secret.",
    onOkText: "Expire secret"
  },
  delete: {
    title: "Delete webhook endpoint",
    text: "Are you sure you want to delete this webhook endpoint? This action cannot be undone.",
    onOkText: "Delete"
  }
}

export const ActionModal = ({ modalType, close, onOk }) => {
  const { t } = useTranslation()
  const [expirePeriod, setExpirePeriod] = useState(null)

  return (
    <Modal
      open={["activate", "disable", "expire_secret", "delete"].includes(modalType)}
      onClose={close}
      onCancel={close}
      footer={null}
      centered={true}
      closeIcon={<Icon type="cross_small" />}
      width={410}
      title={t(`${modalContent[modalType]?.title}`)}
      destroyOnClose
      className="faq-custom-modal"
      classNames={{ content: "clear-bg" }}
    >
      <Text type="secondary" style={{ display: "block", margin: "10px 0 28px" }}>
        {t(`${modalContent[modalType]?.text}`)}
      </Text>

      {modalType === "expire_secret" && (
        <>
          <Text style={{ display: "block" }}>{t("Expiration period")}</Text>
          <SelectComponent
            size={"large"}
            options={modalContent[modalType]?.options.map((option) => ({
              value: option,
              label: option
            }))}
            placeholder={t("Select expiration period")}
            onChange={(v) => setExpirePeriod(v)}
            value={expirePeriod}
            style={{ width: "100%", margin: "8px 0 16px" }}
          />
          <Text type="secondary" style={{ display: "block" }}>
            {t(`${modalContent[modalType]?.text2}`)}
          </Text>
        </>
      )}

      <Flex gap={12} style={{ width: "100%", margin: "40px 0 0", padding: "0 2px" }}>
        <ButtonComponent size="large" className="flex center" onClick={close} block>
          {t("Cancel")}
        </ButtonComponent>

        <ButtonComponent size="large" type="primary" className="flex center" onClick={onOk} block>
          {t(`${modalContent[modalType]?.onOkText}`)}
        </ButtonComponent>
      </Flex>
    </Modal>
  )
}
